import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const WooCommerceSettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">WooCommerce</h6>
          <Form.Text style={{ fontSize: 12 }}>
            To connect your WooCommerce store, enter your store URL, API prefix,
            and credentials.
          </Form.Text>
        </Form.Group>
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 127px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">
                      WooCommerce store URL
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter WooCommerce store URL"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">API Prefix</Form.Label>
                    <Form.Control type="text" placeholder="Enter API Prefix" />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Consumer Key</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Consumer Key"
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Consumer Secret</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Consumer Secret"
                    />
                  </Col>
                </Row>
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default WooCommerceSettings;
